(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpDatatable', cpDatatable);

    cpDatatable.$inject = ['$q', '$state', '$timeout', '$filter', '$sce', 'uiSortableSrvc', 'lodashService', 'datatablePageSizesConst', 'checkModelPermissionsSrvc', 'datatableDefaultEmptyValueConst'];

    function cpDatatable($q, $state, $timeout, $filter, $sce, uiSortableSrvc, lodashService, datatablePageSizesConst, checkModelPermissionsSrvc, datatableDefaultEmptyValueConst) {
        return {
            restrict: 'E',
            replace: true,
            transclude: {
                boxActions: '?boxActions'
            },
            scope: {
                title: '@',
                hideOrderCol: '@',
                hideActionsCol: '@',
                showOnlyExtraActions: '=?',
                loading: '=?',
                cols: '=',
                rows: '=',

                modelPermissions: '=?',
                filtersOnTop: '@?',
                filtersOnBottom: '@?',

                showCheckboxCol: '@',
                checkboxSelectedProp: '@',

                onClick: '&?',
                onReorder: '&?',
                onCreate: '&?',
                onCreateBtnText: '@?',
                onEdit: '&?',
                onDelete: '&?',
                extraActions: '=?',
                contextMenuActions: '=?',
                onEditAsLink: '=?',
                onEditAsLinkUrl: '@?',
                onEditAsLinkUrlParam: '@?',

                rowEdit: '&?',
                isEditable: '=?',
                isOnlyEdit: '=?',
                inputEditClass: '@?',

                pageOpts: '=?',
                pageChange: '&?',

                isAdminList: '=',
                isPartialEditEnabled: '=?',
                logsInfo: '=',

                withSearch: '=?',
                searchQuery: '=?',
                onSearchQueryChange: '&?',
                isSearchingOutside: '=?',

                showColumnEmptyCheckbox: '=?',
                columnEmptyCheckboxCols: '=?',
                columnEmptyCheckboxChange: '&?',

                // For nested collapse table
                withCollapse: '=?',
                collapseLoading: '=?',
                collapseCols: '=?',
                collapseModelProp: '@?',
                collapsePropValue: '@?',
                collapsePropTitle: '@?',
                collapseSubTitle: '@?',
                collapseModelPermissions: '=?',
                collapseOnCreate: '&?',
                collapseOnDelete: '&?',
                collapseOnReorder: '&?',
                collapseOnClick: '&?',
                collapseOptionsClick: '&?',

                summaryCols: '=?',

                withExposing: '=?',
                exposingColors: '=?',
                exposingConditionProp: '=?',
                exposingConditionValue: '=?'
            },
            templateUrl: 'app/caffeprint/directives/datatable/datatable.html',
            link: function(scope, element, attrs, ctrl, $transclude) {
                // data for paging
                scope.pageSizeOpts = datatablePageSizesConst;
                scope.selectPageSizeChange = selectPageSizeChange;
                scope.inputPageSizeChange = inputPageSizeChange;
                scope.maxSize = 5;

                // data for getting col values
                scope.defaultEmptyString = datatableDefaultEmptyValueConst;
                scope.getValue = getValue;
                scope.getTextValue = getTextValue;
                scope.getLinkValue = getLinkValue;
                scope.getJsonValue = getJsonValue;
                scope.getBooleanValueClass = getBooleanValueClass;
                scope.getDecimalValue = getDecimalValue;
                scope.getJoinedValue = getJoinedValue;
                scope.getImageValue = getImageValue;
                scope.getListValue = getListValue;
                scope.getOrderNr = getOrderNr;
                scope.isText = isText;
                scope.isLink = isLink;
                scope.isBoolean = isBoolean;
                scope.isDecimal = isDecimal;
                scope.isImage = isImage;
                scope.isJoin = isJoin;
                scope.isList = isList;
                scope.isJson = isJson;
                scope.withClick = withClick;
                scope.hasHelper = hasHelper;
                scope.helperWithCondition = helperWithCondition;
                scope.getHelperTooltipContent = getHelperTooltipContent;
                scope.hasPopover = hasPopover;
                scope.shouldTriggerPopover = shouldTriggerPopover;

                // data for checkbox row selecting
                scope.check = {};
                scope.checkProp = 'checkProp';
                scope.selectAllCheckboxes = selectAllCheckboxes;

                // data for editable
                scope.selectedRow = {};
                scope.modelErrors = {};
                scope.getTemplate = getTemplate;
                scope.addRow = addRow;
                scope.editRow = editRow;
                scope.saveRow = saveRow;
                scope.resetRow = resetRow;
                scope.cleanErrors = cleanErrors;

                scope.onDblClick = onDblClick;
                scope.isCellEditable = isCellEditable;
                scope.editCell = editCell;

                //data for 'show empty' column checkbox
                scope.selectedEmptyColumns = {};
                scope.showCheckboxForEmpty = showCheckboxForEmpty;

                // data for sort
                scope.currentSortColValue = null;
                scope.getSortBy = getSortBy;
                scope.sortBy = sortBy;

                // data for search
                scope.onSearch = onSearch;
                scope.isSearching = isSearching;
                scope.isSearchable = isSearchable;
                scope.isSearchableBoolean = isSearchableBoolean;
                scope.getSearchColType = getSearchColType;
                scope.getSearchColValue = getSearchColValue;

                // data wuth templates paths
                scope.popoverContentTmpl = 'app/caffeprint/directives/datatable/datatable-logs-popover-template.html';
                scope.editableRow = 'app/caffeprint/directives/datatable/datatable-editable-row.html';
                scope.staticRow = 'app/caffeprint/directives/datatable/datatable-static-row.html';
                scope.partiallyEditableRow = 'app/caffeprint/directives/datatable/datatable-partially-editable-row.html';

                // data for permissions
                scope._isHasCreatePermission = false;
                scope.isHasCreatePermission = isHasCreatePermission;
                scope._isHasEditPermission = false;
                scope.isHasEditPermission = isHasEditPermission;
                scope._isHasDeletePermission = false;
                scope.isHasDeletePermission = isHasDeletePermission;

                // data for checking what buttons should be displayed
                scope.isShowCreateButton = isShowCreateButton;
                scope.isShowAddRowButton = isShowAddRowButton;
                scope.isShowActionCol = isShowActionCol;
                scope.hasBoxActions = hasBoxActions;

                // data for nested collapse tables
                scope.toggle = [];

                // data for columns summary
                scope.getColSummary = getColSummary;

                // data for context menu
                scope.isWithContextMenu = isWithContextMenu;

                // for exposing row
                scope.isExposing = isExposing;
                scope.getExposingColor = getExposingColor;

                // for extra action click event
                scope.onExtraActionClick = onExtraActionClick;

                // for field with popup click
                scope.clickActionFieldClick = clickActionFieldClick;

                // data for sortable
                scope.sortableOptions = {
                    items: 'tbody:not(.search-row)',
                    stop: function(e, ui) {
                        uiSortableSrvc.getStopFn(scope.onReorder, scope.rows, e, ui, scope.withSearch);
                    },
                    helper: function(e, tbody) {
                        var $originals = tbody.children().first().children();
                        var $helper = tbody.clone();
                        $helper.children().first().children().each(function(index) {
                            // Set helper cell sizes to match the original sizes
                            angular.element(this).width($originals.eq(index).width());
                        });
                        return $helper;
                    }
                };

                scope.$watch('isSearchingOutside', function() {
                    updateDragable();
                });

                scope.$on("onCleanSearchFilters", function(e, data){
                    if(data.searchQuery) {
                        scope.searchQuery = data.searchQuery;
                    }
                    scope.onSearch();
                });

                activate();

                function activate() {
                    if (scope.modelPermissions) {
                        if (scope.modelPermissions.add) {
                            scope._isHasCreatePermission = checkModelPermissionsSrvc.isDenied(
                                scope.modelPermissions.add) === false;
                        }

                        if (scope.modelPermissions.update) {
                            scope._isHasEditPermission = checkModelPermissionsSrvc.isDenied(
                                scope.modelPermissions.update) === false;
                        }

                        if (scope.modelPermissions.delete) {
                            scope._isHasDeletePermission = checkModelPermissionsSrvc.isDenied(
                                scope.modelPermissions.delete) === false;
                        }
                    }

                    updateDragable();
                }

                function showCheckboxForEmpty(colVal) {
                    return (scope.showColumnEmptyCheckbox && scope.columnEmptyCheckboxCols.indexOf(colVal) >= 0)
                }


                function pageSizeChange() {
                    scope.pageOpts.page = 1;

                    if (scope.pageChange) {
                        scope.pageChange();
                    }
                }

                function selectPageSizeChange() {
                    scope.pageOpts.inputPageSize = undefined;
                    pageSizeChange();
                }

                function inputPageSizeChange() {
                    scope.pageOpts.pageSize = scope.pageOpts.inputPageSize;
                    pageSizeChange();
                }

                function getValue(obj, key) {
                    return key.split(".").reduce(function(result, key) {
                        return result && result[key] ? result[key] : null;
                    }, obj);
                }

                function getTextValue(obj, key) {
                    return getValue(obj, key) || scope.defaultEmptyString;
                }

                function getJsonValue(obj, key) {
                    return JSON.stringify(getValue(obj, key));
                }

                function getLinkValue(obj, col) {
                    return $state.href(col.linkTo, {pk: obj[col.linkParamProp]});
                }

                function getBooleanValueClass(obj, key) {
                    if (getValue(obj, key)) {
                        return 'fa fa-check text-navy';
                    } else {
                        return 'fa fa-times text-danger';
                    }
                }

                function getDecimalValue(obj, key) {
                    var value = getValue(obj, key);
                    if (value) {
                        return $filter('number')(value, 2);
                    } else {
                        return scope.defaultEmptyString;
                    }
                }

                function getJoinedValue(obj, keys, separator) {
                    return keys.split('&').map(function(key) {
                        return getValue(obj, key);
                    }).filter(function(key) {
                        return !!key;
                    }).join(separator) || scope.defaultEmptyString;
                }

                function getImageValue(obj, key) {
                    return getValue(obj, key) || null;
                }

                function getListValue(obj, key) {
                    return getValue(obj, key) || [];
                }

                function getOrderNr(page, index) {
                    if (scope.pageSize) {
                        return index + 1 + scope.pageOpts.pageSize * (page - 1);
                    } else {
                        return index + 1;
                    }
                }

                function isText(column) {
                    return column.type === "text" ||
                        column.type === "number" ||
                        column.type === "date" ||
                        column.type === "datetime" ||
                        column.type === undefined;
                }

                function withClick(column) {
                    if (column.onClick === undefined) {
                        return false;
                    } else {
                        return true;
                    }
                }

                function isLink(column) {
                    return column.type === "link";
                }

                function isBoolean(column) {
                    return column.type === "boolean";
                }

                function isDecimal(column) {
                    return column.type === "decimal";
                }

                function isImage(column) {
                    return column.type === "image";
                }

                function isJoin(column) {
                    return column.type === "join";
                }

                function isList(column) {
                    return column.type === "list";
                }
                function isJson(column) {
                    return column.type === 'json';
                }

                function hasHelper(column) {
                    return column.hasOwnProperty('helpers');
                }

                function helperWithCondition(helper, row) {
                    if (helper.hasOwnProperty('conditionProp')) {
                        return !!row[helper.conditionProp];
                    } else {
                        return true;
                    }
                }

                function getHelperTooltipContent(helper, row) {
                    if (helper.directTooltip) {
                        return helper.tooltip;
                    } else {
                        return getValue(row, helper.tooltip)
                    }
                }

                function selectAllCheckboxes() {
                    for (var i = 0; i < scope.rows.length; ++i) {
                        scope.rows[i][scope.checkboxSelectedProp] = scope.check[scope.checkProp];
                    }
                }

                function getTemplate(row) {
                    if (scope.selectedRow.pk && row.pk && scope.selectedRow.pk === row.pk) {
                        return scope.editableRow;
                    } else if (scope.isPartialEditEnabled) {
                        return scope.partiallyEditableRow;
                    } else {
                        return scope.staticRow;
                    }
                }

                function addRow() {
                    var new_row = {
                        'pk': '$_' + (scope.rows.length + 1)
                    };

                    angular.forEach(scope.cols, function(col) {
                        new_row[col.value] = null;
                    });

                    scope.rows.push(angular.copy(new_row));
                    scope.selectedRow = angular.copy(new_row);
                }

                function editRow(row) {
                    scope.selectedRow = angular.copy(row);
                }

                function saveRow(index) {
                    if (scope.rowEdit) {
                        var isNewRow = typeof scope.selectedRow.pk === "string" ? true : false;
                        var currentRow = angular.copy(scope.selectedRow);
                        var editCallback = scope.rowEdit({ row: currentRow, isNewRow: isNewRow });

                        if (editCallback && editCallback.$promise) {
                            editCallback.$promise.then(
                                function(response) {
                                    scope.rows[index] = angular.copy(scope.selectedRow);
                                    if (!scope.isOnlyEdit) {
                                        scope.rows[index].pk = response.pk;
                                    }
                                    scope.resetRow(index);
                                },
                                function(response) {
                                    scope.modelErrors[scope.rows[index].pk] = response.data;
                                }
                            );
                        } else {
                            validateAndResetRow(index);
                        }
                    } else {
                        validateAndResetRow(index);
                    }
                }

                function resetRow(index) {
                    angular.forEach(
                        scope.modelErrors[scope.rows[index].pk],
                        function(field, key) {
                            scope.cleanErrors(scope.rows[index].pk, key);
                        }
                    );

                    var isRowEmpty = lodashService.every(scope.cols, function(field) {
                        return scope.selectedRow[field.value] === null;
                    });

                    if (isRowEmpty) {
                        lodashService.remove(scope.rows, { pk: scope.selectedRow.pk });
                    }

                    scope.selectedRow = {};
                }

                function cleanErrors(pk, key) {
                    if (!scope.modelErrors[pk]) {
                        scope.modelErrors[pk] = {};
                    }

                    scope.modelErrors[pk][key] = [];
                }

                function validateSingleField(field, row) {
                    var valid = true;
                    if (field.isEditable) {
                        scope.cleanErrors(row.pk, field.value);
                        if (field.required && (row[field.value] === null || row[field.value] === undefined)) {
                            valid = false;
                            scope.modelErrors[row.pk][field.value].push('To pole jest wymagane.');
                        }
                        if (field.minValue !== undefined &&
                            row[field.value] !== null &&
                            row[field.value] < field.minValue) {
                            valid = false;
                            scope.modelErrors[row.pk][field.value].push('Upewnij się, że ta wartość jest większa lub równa ' + field.minValue + '.');
                        }
                        return valid;
                    } else {
                        return valid;
                    }
                }

                function validate() {
                    return lodashService.every(scope.cols, function(field) {
                        return validateSingleField(field, scope.selectedRow);
                    });
                }

                function validateAndResetRow(index) {
                    if (validate()) {
                        scope.rows[index] = angular.copy(scope.selectedRow);
                        scope.selectedRow = {};
                    }
                }

                function onDblClick(col, row, $event) {
                    if (col.isAlwaysShowInput && col.inputConditionField && !row[col.inputConditionField]) {
                        return;
                    }

                    if (!row.editedCells) {
                        row.editedCells = {};
                    }
                    row.editedCells[this.col.value] = true;

                    $timeout(function() {
                        angular.element($event.currentTarget).find('input').focus();
                    });
                }

                function isCellEditable(col, row) {
                    return col.isEditable && scope.isHasEditPermission() &&
                        ((col.isAlwaysShowInput && col.inputConditionField && row[col.inputConditionField]) || (row.editedCells && row.editedCells[col.value]));
                }

                function editCell(col, row) {
                    if (!validateSingleField(col, row)) {
                        return;
                    }

                    if (scope.rowEdit) {
                        var editCallback = scope.rowEdit({ row: row });

                        if (editCallback && editCallback.$promise) {
                            editCallback.$promise.then(
                                function(response) {
                                    if (col.isAlwaysShowInput && col.inputConditionField && !row[col.inputConditionField]) {
                                        return;
                                    }

                                    row.editedCells[col.value] = false;
                                },
                                function(response) {
                                    scope.modelErrors[row.pk] = response.data;
                                }
                            );
                        } else {
                            cellBlur(col, row);
                        }
                    } else {
                        cellBlur(col, row);
                    }
                }

                function cellBlur(col, row) {
                    if (col.isAlwaysShowInput && col.inputConditionField && !row[col.inputConditionField]) {
                        return;
                    } else  {
                        row.editedCells[col.value] = false;
                    }
                }

                function isCanDrag() {
                    return scope.onReorder &&
                        !isSearching() &&
                        !scope.currentSortColValue &&
                        !scope.isSearchingOutside;
                }

                function updateDragable() {
                    if (isCanDrag()) {
                        scope.sortableOptions.disabled = false;
                    } else {
                        scope.sortableOptions.disabled = true;
                    }
                }

                function getSortBy(col) {
                    return col.orderValue ? col.orderValue : col.value;
                }

                function sortBy(col) {
                    if (!col.orderable) {
                        return;
                    }

                    var currentSortProperty = getSortBy(col);

                    if (scope.searchQuery) {
                        if (scope.currentSortColValue === currentSortProperty) {
                            scope.currentSortColValue = "-" + currentSortProperty;
                        } else if (scope.currentSortColValue === "-" + currentSortProperty) {
                            scope.currentSortColValue = null;
                        } else {
                            scope.currentSortColValue = currentSortProperty;
                        }

                        if (scope.searchQuery.hasOwnProperty('ordering')) {
                            scope.searchQuery.ordering = scope.currentSortColValue ?
                                scope.currentSortColValue.replace('.', '__').replace('.', '__').replace('&', ',') :
                                scope.currentSortColValue;

                            if (scope.onSearchQueryChange) {
                                scope.onSearchQueryChange();
                            }
                        }

                        updateDragable();
                    }
                }

                function onSearch() {
                    updateDragable();

                    if (scope.onSearchQueryChange) {
                        scope.onSearchQueryChange();
                    }
                }

                function isSearching() {
                    return scope.searchQuery && lodashService.some(scope.searchQuery, function(elem) {
                        if (typeof elem === 'boolean') {
                            return true;
                        } else {
                            return Boolean(elem);
                        }
                    });
                }

                function isSearchable(col) {
                    return col.searchable && (
                        scope.isText(col) ||
                        scope.isLink(col) ||
                        scope.isJoin(col) ||
                        scope.isDecimal(col)
                    );
                }

                function isSearchableBoolean(col) {
                    return col.searchable && scope.isBoolean(col);
                }

                function getSearchColType(column) {
                    if (column.type === 'image') {
                        return 'image';
                    } else if (column.type === 'boolean') {
                        return 'boolean';
                    } else if (column.type === 'text' || column.type === 'date' || column.type === 'datetime') {
                        return 'text';
                    } else if (column.type === 'number' || column.type === 'decimal') {
                        return 'number';
                    }
                }

                function getSearchColValue(col) {
                    if (col.searchValue) {
                        return col.searchValue;
                    }

                    return col.value;
                }

                function getColSummary(col) {
                    return scope.rows.reduce(function(a, b) {
                        return a + scope.getValue(b, scope.summaryCols[col.value]);
                    }, 0.0);
                }

                function isWithContextMenu() {
                    return scope.contextMenuActions && scope.contextMenuActions.filter(function(item) {
                        return !lodashService.has(item, 'displayed') || item.displayed();
                    }).length;
                }

                function isHasCreatePermission() {
                    return !scope.modelPermissions ||
                        !scope.modelPermissions.add ||
                        scope._isHasCreatePermission;
                }

                function isHasEditPermission() {
                    return !scope.modelPermissions ||
                        !scope.modelPermissions.update ||
                        scope._isHasEditPermission;
                }

                function isHasDeletePermission() {
                    return !scope.modelPermissions ||
                        !scope.modelPermissions.delete ||
                        scope._isHasDeletePermission;
                }

                function isShowCreateButton() {
                    return scope.onCreate && !scope.isEditable && scope.isHasCreatePermission();
                }

                function isShowAddRowButton() {
                    return scope.isEditable && !scope.isOnlyEdit && scope.isHasCreatePermission();
                }

                function isShowActionCol() {
                    return scope.showOnlyExtraActions || (!scope.hideActionsCol && (
                               (scope.onEdit && scope.isHasEditPermission()) ||
                               (scope.isEditable && scope.isHasEditPermission()) ||
                               (scope.onDelete && scope.isHasDeletePermission()) ||
                               scope.logsInfo ||
                               scope.extraActions ||
                               scope.collapseOptionsClick));
                }

                function isExposing(row) {
                    if (Array.isArray(scope.exposingConditionValue)) {
                        return scope.withExposing && scope.exposingConditionValue.indexOf(row[scope.exposingConditionProp]) !== -1;
                    } else {
                        return scope.withExposing && row[scope.exposingConditionProp] === scope.exposingConditionValue;
                    }
                }

                function clickActionFieldClick(col, row) {
                    col.onClick(row);
                }

                function onExtraActionClick(extraAction, row, id) {
                    if (extraAction.withLoading) {
                        if (row.actionLoading === undefined) row.actionLoading = {};
                        row.actionLoading[id] = true;
                        $q.all([extraAction.onClick(row)]).then(
                            function () {
                                row.actionLoading[id] = false;
                            },
                            function () {
                                row.actionLoading[id] = false;
                            }
                        );

                    } else {
                        extraAction.onClick(row);
                    }
                }

                function getExposingColor(row) {
                    return scope.exposingColors[row[scope.exposingConditionProp]];
                }

                function hasBoxActions() {
                    return $transclude.isSlotFilled('boxActions');
                }

                function hasPopover(column) {
                    return column.hasOwnProperty('popover');
                }

                function shouldTriggerPopover(col, eventType) {
                    if (!hasPopover(col)) return false;

                    var action = (col.popover.openAction || 'outsideClick');

                    if (eventType === 'click' && action === 'outsideClick') return true;

                    return action.split(' ').indexOf(eventType) !== -1;
                }
            }
        };
    }
})();
